import { jsxs, jsx, Fragment as Fragment$1 } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import HeaderComponent from "@effektify/components/Header";
import { isCard, isHeader, isMdTag, isContainer } from "@effektify/types/guards";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import { Fragment } from "react";
import "@effektify/logger";
import "@effektify/types";
import "sprintf-js";
import useVariables from "../../hooks/useVariables.js";
import "@effektify/components";
import "@effektify/cache";
import useCardSizes from "../../hooks/useCardSizes.js";
import "../Card/CardRenderer.js";
import { CardWithData } from "../Card/CardWithData.js";
const filterPassedDownClassNames = className => className.split(" ").filter(cls => ["color-scheme-sand", "color-scheme-forest", "color-scheme-volt", "color-scheme-blaze"].includes(cls)).join(" ");
const getGridSize = count => {
  if (count === 0) return 12;
  if (count === 1) return 12;
  if (count === 2) return 6;
  if (count % 4 === 0) return 3;
  if (count % 3 === 0) return 4;
  return Math.max(12 / count, 2);
};
const border = 0;
const containerGroupStyle = {
  overflow: "clip",
  borderRadius: "0.75rem",
  boxShadow: "0px 1px 3px 0px rgba(36, 5, 5, 0.1)"
};
const GridItem = t0 => {
  const $ = c(8);
  const {
    children,
    width,
    minHeight
  } = t0;
  const t1 = width ?? "grow";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      xs: 12,
      sm: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== minHeight) {
    t3 = {
      minHeight,
      border
    };
    $[2] = minHeight;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children || $[5] !== t2 || $[6] !== t3) {
    t4 = /* @__PURE__ */jsx(Grid, {
      size: t2,
      sx: t3,
      children
    });
    $[4] = children;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
const GridHeaderItem = t0 => {
  const $ = c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === /* @__PURE__ */Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      height: "auto",
      border,
      marginTop: "2rem"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = /* @__PURE__ */jsx(Grid, {
      size: 12,
      sx: t1,
      children
    });
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const HorizontalContainer = t0 => {
  const $ = c(15);
  const {
    children,
    width,
    minHeight,
    grouped
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] !== grouped) {
    t1 = grouped === true ? containerGroupStyle : {};
    $[0] = grouped;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const groupStyle = t1;
  let t2;
  if ($[2] !== grouped || $[3] !== theme) {
    t2 = grouped === true ? "1px" : theme.spacing(4);
    $[2] = grouped;
    $[3] = theme;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = width ?? "grow";
  let t4;
  if ($[5] !== t3) {
    t4 = {
      xs: 12,
      sm: t3
    };
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== groupStyle || $[8] !== minHeight) {
    t5 = {
      justifyContent: "left",
      alignItems: "stretch",
      minHeight,
      border,
      ...groupStyle
    };
    $[7] = groupStyle;
    $[8] = minHeight;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== children || $[11] !== t2 || $[12] !== t4 || $[13] !== t5) {
    t6 = /* @__PURE__ */jsx(Grid, {
      container: true,
      spacing: t2,
      size: t4,
      sx: t5,
      children
    });
    $[10] = children;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
const VerticalContainer = t0 => {
  const $ = c(15);
  const {
    children,
    width,
    minHeight,
    grouped
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] !== grouped) {
    t1 = grouped === true ? containerGroupStyle : {};
    $[0] = grouped;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const groupStyle = t1;
  const t2 = width ?? "grow";
  let t3;
  if ($[2] !== grouped || $[3] !== theme) {
    t3 = grouped === true ? "1px" : theme.spacing(4);
    $[2] = grouped;
    $[3] = theme;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== groupStyle) {
    t4 = {
      height: "100%",
      justifyContent: "center",
      alignItems: "stretch",
      border,
      ...groupStyle
    };
    $[5] = groupStyle;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== children || $[8] !== t3 || $[9] !== t4) {
    t5 = /* @__PURE__ */jsx(Stack, {
      spacing: t3,
      sx: t4,
      children
    });
    $[7] = children;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== minHeight || $[12] !== t2 || $[13] !== t5) {
    t6 = /* @__PURE__ */jsx(GridItem, {
      width: t2,
      minHeight,
      children: t5
    });
    $[11] = minHeight;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
const VerticalContainerItem = t0 => {
  const $ = c(6);
  const {
    children,
    minHeight,
    height: t1
  } = t0;
  const height = t1 === void 0 ? "100%" : t1;
  let t2;
  if ($[0] !== height || $[1] !== minHeight) {
    t2 = {
      height,
      minHeight,
      border
    };
    $[0] = height;
    $[1] = minHeight;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = /* @__PURE__ */jsx(Box, {
      sx: t2,
      children
    });
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
const Container = t0 => {
  const $ = c(20);
  const {
    content,
    isGrouped,
    loading,
    className,
    isVertical
  } = t0;
  const {
    getCardDimensions
  } = useCardSizes();
  const {
    hasMetConditions
  } = useVariables();
  let t1;
  if ($[0] !== hasMetConditions) {
    t1 = conditions => hasMetConditions(conditions);
    $[0] = hasMetConditions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const shouldRender = t1;
  let t2;
  if ($[2] !== shouldRender) {
    t2 = item => {
      if ("conditions" in item && item.conditions) {
        return shouldRender(item.conditions);
      }
      return true;
    };
    $[2] = shouldRender;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const shouldRenderItem = t2;
  let t3;
  if ($[4] !== getCardDimensions || $[5] !== shouldRenderItem) {
    t3 = x => {
      if (isHeader(x)) {
        return false;
      }
      if (isCard(x) && getCardDimensions(x.variant).width === 12 || !shouldRenderItem(x)) {
        return false;
      }
      return true;
    };
    $[4] = getCardDimensions;
    $[5] = shouldRenderItem;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const filter = t3;
  let t4;
  if ($[7] !== className || $[8] !== content || $[9] !== filter || $[10] !== getCardDimensions || $[11] !== isGrouped || $[12] !== isVertical || $[13] !== loading || $[14] !== shouldRenderItem) {
    let t52;
    if ($[16] !== filter) {
      t52 = x_0 => filter(x_0);
      $[16] = filter;
      $[17] = t52;
    } else {
      t52 = $[17];
    }
    const gridSize = getGridSize(content.filter(t52).length);
    t4 = content.map((item_0, idx) => {
      if (!shouldRenderItem(item_0)) {
        return null;
      }
      const dimensions = getCardDimensions(isCard(item_0) ? item_0.variant : void 0, isCard(item_0) ? item_0 : void 0, gridSize);
      return /* @__PURE__ */jsxs(Fragment, {
        children: [isHeader(item_0) && /* @__PURE__ */jsx(GridHeaderItem, {
          children: /* @__PURE__ */jsx(HeaderComponent, {
            isMarkdown: isMdTag(item_0.title),
            title: item_0.title,
            description: item_0.description,
            icon: "icon" in item_0 && item_0.icon ? item_0.icon : null
          })
        }), isCard(item_0) && !isVertical && /* @__PURE__ */jsx(GridItem, {
          width: dimensions.width,
          minHeight: dimensions.minHeightInRem,
          children: /* @__PURE__ */jsx(CardWithData, {
            className: [filterPassedDownClassNames(className || ""), isGrouped ? "grouped" : ""].join(" "),
            config: item_0,
            loading
          }, `card-${item_0.id}`)
        }, `grid-item-${item_0.id}-${idx}`), isCard(item_0) && isVertical && /* @__PURE__ */jsx(VerticalContainerItem, {
          minHeight: dimensions.minHeightInRem,
          children: /* @__PURE__ */jsx(CardWithData, {
            className: [filterPassedDownClassNames(className || ""), isGrouped ? "grouped" : ""].join(" "),
            config: item_0,
            loading
          }, `card-${item_0.id}`)
        }, `grid-item-${item_0.id}-${idx}`), isContainer(item_0) && !item_0.isVertical && /* @__PURE__ */jsx(HorizontalContainer, {
          width: item_0.width ?? gridSize,
          grouped: item_0.isGrouped,
          children: /* @__PURE__ */jsx(Container, {
            content: item_0.content,
            isGrouped: item_0.isGrouped,
            isVertical: item_0.isVertical ?? false,
            conditions: item_0.conditions,
            className: "colorScheme" in item_0 && item_0.colorScheme ? `color-scheme-${item_0.colorScheme}` : "",
            loading
          }, `${item_0.id}-container-${idx}`)
        }, idx), isContainer(item_0) && item_0.isVertical && /* @__PURE__ */jsx(VerticalContainer, {
          width: item_0.width ?? gridSize,
          grouped: item_0.isGrouped,
          children: /* @__PURE__ */jsx(Container, {
            content: item_0.content,
            isGrouped: item_0.isGrouped,
            isVertical: item_0.isVertical ?? false,
            conditions: item_0.conditions,
            className: "colorScheme" in item_0 && item_0.colorScheme ? `color-scheme-${item_0.colorScheme}` : "",
            loading
          }, `${item_0.id}-container-${idx}`)
        }, idx)]
      }, `container-fragment-${idx}`);
    });
    $[7] = className;
    $[8] = content;
    $[9] = filter;
    $[10] = getCardDimensions;
    $[11] = isGrouped;
    $[12] = isVertical;
    $[13] = loading;
    $[14] = shouldRenderItem;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[18] !== t4) {
    t5 = /* @__PURE__ */jsx(Fragment$1, {
      children: t4
    });
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
};
export { GridHeaderItem, GridItem, HorizontalContainer, VerticalContainer, VerticalContainerItem, Container as default };